import React from 'react'

import { useSettings } from '../../hooks/useSettings'

const DoneSVG = ({
  styles,
  allowLightMode = true,
  isDisabled = false,
  isGreen = false,
}) => {
  const { isDarkMode } = useSettings()

  const color = isDarkMode || !allowLightMode ? '#8cb7ed' : '#0E2E4C'

  return (
    <svg
      className={styles}
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      fill="none"
      opacity={isDisabled ? 0.5 : 1}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g strokeWidth="0" />
      <g strokeLinecap="round" strokeLinejoin="round" />
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2287 6.60355C21.6193 6.99407 21.6193 7.62723 21.2287 8.01776L10.2559 18.9906C9.86788 19.3786 9.23962 19.3814 8.84811 18.9969L2.66257 12.9218C2.26855 12.5349 2.26284 11.9017 2.64983 11.5077L3.35054 10.7942C3.73753 10.4002 4.37067 10.3945 4.7647 10.7815L9.53613 15.4677L19.1074 5.89644C19.4979 5.50592 20.1311 5.50591 20.5216 5.89644L21.2287 6.60355Z"
          fill={isGreen ? '#70d45a' : color}
        />
      </g>
    </svg>
  )
}

export default DoneSVG
